import { WakenMsaRequest, WakenMssResponse } from "./Msa.dto";
import { MsaUrl } from "./Msa.url";
import { restReq } from "../common/cyan.types";
import { FxApiRequestData, FxRequestData } from "../common/flax.types";

export class MsaFlax {
  public static waken(data: FxRequestData<WakenMsaRequest>): FxApiRequestData<WakenMssResponse> {
    return {
      ...restReq(process.env.REACT_APP_ORCHESTRA_URL || process.env.REACT_APP_ORCHESTRA_BE_URL, MsaUrl.waken, data),
      reducer: resp => resp,
      errReducer: resp => resp,
    };
  }
}
